/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 

const template= html`
       <div class="flex-horizontal medium" > 
       <style> 
         
        </style>
       
            Debit Card Authorization
        <p id="rcorners2">
        <!--Debit Card number element starts -->
            <oe-input 
                      id="DebitCardAuth_number_input"
                      auto-validate 
                      char-counter 
                      prevent-invalid-input 
                      error-message="Only sixteen digit number is allowed"
                      pattern="[0-9]{16}"
                      maxlength='16'
                      allowed-pattern="[0-9 ]"
                      value='{{maskedAccountId(wrapperValueInput.DebitCardAuth_number_input,'DBT')}}' 
                      type='password'
                      label="h_DebitCardNumber" 
                      type="tel">
            </oe-input>
        <!--Debit Card number element ends -->
            <!--PIN number element starts --> 
            <oe-input 
                      auto-validate 
                      char-counter 
                      prevent-invalid-input 
                      error-message="Only four digit number is allowed" 
                      pattern="[0-9]{4}"
                      maxlength='4' 
                      id="DebitCardAuth_pin_input" 
                      value={{wrapperValueInput.DebitCardAuth_pin_input}} 
                      label="l_PIN" 
                      type="password"
                      >
            </oe-input>
           
         <!--PIN number element ends --> 
            
         <!--Expiration Date elements starts -->
        
		<gold-cc-expiration-input 
                id="DebitCardAuth_expDate_input" 
                label="l_ExpirationMonthYear"
                error-message="Invalid input"
                value="{{wrapperValueInput.DebitCardAuth_expDate_input}}"
                auto-validate
                required>
        </gold-cc-expiration-input>
        <!--Expiration Date elements ends -->  
            
        </p>    
            
      </div>`;

    Polymer({
      is: 'fin-auth-debit-card',
      _template:template,
      properties: {
          wrapperValue:{
              type: Array,
              value:[
                     { DebitCardAuth_number_input: {type: Number, notify: true}},
                     { DebitCardAuth_pin_input: {type: Number, notify: true }},
                     { DebitCardAuth_expDate_input: {type: Number,notify: true}} 
                   ],
              notify: true
          },
          wrapperValueInput:{
              type: Array,
              value:[
                     { DebitCardAuth_number_input: {type: Number, notify: true}},
                     { DebitCardAuth_pin_input: {type: Number, notify: true }},
                     { DebitCardAuth_expDate_input: {type: Number,notify: true}} 
                   ],
              notify: true
          }
          
      },
    observers: ['onwrapperValueChanged(wrapperValue.*)'],
    attached :function(){
        var self = this;
        var inputFeild = document.getElementById("DebitCardAuth_number_input");
        inputFeild.addEventListener("input", function(){
        self.wrapperValue.DebitCardAuth_number_input = sbEncrypt.encrypt(self.wrapperValueInput.DebitCardAuth_number_input);
        //if(self.wrapperValue.DebitCardAuth_number_input == ''){}
       
        });

        var inputFeild1 = document.getElementById("DebitCardAuth_pin_input");
        inputFeild1.addEventListener("input", function(){
        self.wrapperValue.DebitCardAuth_pin_input = sbEncrypt.encrypt(self.wrapperValueInput.DebitCardAuth_pin_input);
        //if(self.wrapperValue.DebitCardAuth_pin_input == ''){}
   
        });

        var inputFeild2 = document.getElementById("DebitCardAuth_expDate_input");
        inputFeild2.addEventListener("input", function(){
        self.wrapperValue.DebitCardAuth_expDate_input = sbEncrypt.encrypt(self.wrapperValueInput.DebitCardAuth_expDate_input);
        //if(self.wrapperValue.DebitCardAuth_expDate_input == ''){}
      
        });
    },   
  maskedAccountId: function (accountId, codeType) {
    return maskAccount.accountFormat(accountId, codeType);
  },
    onwrapperValueChanged:function(){
        this.fire('auth-pass-changed',this.wrapperValue);
    },
    behaviors: [Polymer.PaperInputBehavior]               
});
    


